import { render, staticRenderFns } from "./ServiceManager.vue?vue&type=template&id=2d31a371&scoped=true&"
import script from "./ServiceManager.vue?vue&type=script&lang=js&"
export * from "./ServiceManager.vue?vue&type=script&lang=js&"
import style0 from "./ServiceManager.vue?vue&type=style&index=0&id=2d31a371&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31a371",
  null
  
)

export default component.exports